import {
  CREATE_USER_SUCCESS,
  CREATE_USER_FAIL,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  GET_DOMAINS,
} from "../actions/types";
import { getAuth } from "../common/Helpers";

const user = JSON.parse(getAuth());

const initialState = user
? { isLoggedIn: true, user }
: { isLoggedIn: false, user: null };

export default function (state = initialState, action) {
  const { type, payload } = action;
  
  switch (type) {
    case CREATE_USER_SUCCESS:
    return {
      ...state,
      isLoggedIn: true,
    };
    case CREATE_USER_FAIL:
    return {
      ...state,
      isLoggedIn: false,
    };
    case EDIT_PROFILE_SUCCESS:
    return {
      ...state,
      isLoggedIn: true,
    };
    case EDIT_PROFILE_FAIL:
    return {
      ...state,
      isLoggedIn: true,
    };
    case GET_DOMAINS:
    return {
      ...state,
      isLoggedIn: true,
    };
    case LOGIN_SUCCESS:
    return {
      ...state,
      isLoggedIn: true,
      user: payload.user,
    };
    case LOGIN_FAIL:
    return {
      ...state,
      isLoggedIn: false,
      user: null,
    };
    case LOGOUT:
    return {
      ...state,
      isLoggedIn: false,
      user: null,
    };
    default:
    return state;
  }
}
